import { useTranslation } from "react-i18next";
import { useStyle } from "@features/ManageSim/css/eSimDetailsStyle";
import { CopyTextField } from "@common/CopyTextField/CopyTextField";
import { Grid, Link, Stack, Typography } from "@mui/material";
import { IESim } from "@pages/AccountDetails/interface/IAccountDetailsPage";

interface IParams {
    eSimDetails: IESim;
}

export const ESimDetails = (props: IParams) => {
    const { eSimDetails } = props;
    const { t } = useTranslation(["accountDetails", "common"]);
    const { classes } = useStyle();

    return (
        <Grid container spacing={2} style={{ width: "auto" }}>
            <Grid item sm={6} xs={12}>
                <Stack spacing={2}>
                    <Typography color="primary" textAlign={{ xs: "center", sm: "left" }} variant="h4">
                        {t("accountDetails:eSimDetails")}
                    </Typography>
                    <Typography textAlign={{ xs: "center", sm: "left" }} variant="normal">
                        {t("accountDetails:scanTheQrCode")}
                    </Typography>
                </Stack>
            </Grid>
            <Grid item sm={3} xs={12}>
                <Stack alignItems="center">
                    <img
                        alt="QR Code"
                        className={classes.qrCodeImage}
                        src={`data:image/${eSimDetails.activationQrCodeFormat};base64,${eSimDetails.activationQrCode}`}
                    />
                    <Link
                        download="QR Code"
                        href={`data:image/${eSimDetails.activationQrCodeFormat};base64,${eSimDetails.activationQrCode}`}
                        underline="always"
                    >
                        <Typography align="center" color="primary">
                            {t("common:downloadQrCode")}
                        </Typography>
                    </Link>
                </Stack>
            </Grid>
            <Grid item sm={3} xs={12}>
                <Stack height="100%" justifyContent="center">
                    <CopyTextField text={eSimDetails.esimPassCode} width="100%" />
                </Stack>
            </Grid>
        </Grid>
    );
};
